import { DatetimeService } from './../../api/datetime.service';
import { Component, OnInit, Input } from '@angular/core';
import { Buchung } from 'src/app/api/buchung';

@Component({
  selector: 'app-buchung-card',
  templateUrl: './buchung-card.component.html',
  styleUrls: ['./buchung-card.component.scss']
})
export class BuchungCardComponent implements OnInit {
  @Input() buchung: Buchung;
  public status: string;
  public datumStr: string;
  public flipped = false;

  constructor(private dateTimeService: DatetimeService) { }

  ngOnInit() {
    this.datumStr = this.dateTimeService.getDatumStr(this.buchung.datum);
    let n: number = +this.buchung.umsatz;
    if (this.buchung.sollkonto.typ === 'A') {
      if (n >= 100) {
        this.status = "danger";
      }
    }
  }

  public toggleView(): void {
    this.flipped = !this.flipped;
  }

}
